const BASE = process.env.REACT_APP_API_URL ?? '';

// Populated by AuthContext during initialization so the client can trigger a
// logout redirect without creating a circular import.
export let onUnauthorized: () => void = () => {};

export function setOnUnauthorized(cb: () => void): void {
  onUnauthorized = cb;
}

async function request(
  method: string,
  path: string,
  options: RequestInit = {}
): Promise<Response> {
  const url = `${BASE}${path}`;
  const res = await fetch(url, {
    ...options,
    method,
    credentials: 'include',
  });

  // Suppress the global redirect for the initial session probe — AuthGuard
  // handles the null-user case for that call.
  const isAuthMe = path === '/api/auth/me';
  if (res.status === 401 && !isAuthMe) {
    onUnauthorized();
  }

  return res;
}

export async function apiGet(
  path: string,
  options: { signal?: AbortSignal } = {}
): Promise<Response> {
  return request('GET', path, options.signal ? { signal: options.signal } : {});
}

export async function apiPost(path: string, body: unknown): Promise<Response> {
  return request('POST', path, {
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function apiPut(path: string, body: unknown): Promise<Response> {
  return request('PUT', path, {
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function apiDelete(path: string): Promise<Response> {
  return request('DELETE', path);
}

// For multipart form uploads — do not set Content-Type; the browser sets it
// automatically with the correct boundary when given a FormData body.
export async function apiPostForm(
  path: string,
  formData: FormData
): Promise<Response> {
  return request('POST', path, { body: formData });
}
